/* eslint-disable no-unused-vars */
export enum CnpCaptureStates {
  CUSTOMER_CAPTURE = "CUSTOMER_CAPTURE",
  LINE_ITEM_CAPTURE = "LINE_ITEM_CAPTURE",
  PAYMENT_TERMS = "PAYMENT_TERMS",
  REVIEW = "REVIEW",
}

export enum CnpCaptureMessages {
  CUSTOMER_DETAILS = "Add your customer's details",
  LINE_ITEM_CAPTURE = "Add your line items",
  PAYMENT_TERMS = "Set your payment terms",
}

export enum DocumentType {
  INVOICE = "INVOICE",
  QUOTE = "QUOTE",
  RECEIPT = "RECEIPT",
}

export enum StatementStatus {
  DRAFT = "DRAFT",
  UNPAID = "UNPAID",
  PAID = "PAID",
  CANCELLED = "CANCELLED",
}

export enum Province {
  EASTERN_CAPE = "EASTERN_CAPE",
  FREE_STATE = "FREE_STATE",
  GAUTENG = "GAUTENG",
  KWAZULU_NATAL = "KWAZULU_NATAL",
  LIMPOPO = "LIMPOPO",
  MPUMALANGA = "MPUMALANGA",
  NORTHERN_CAPE = "NORTHERN_CAPE",
  NORTH_WEST = "NORTH_WEST",
  WESTERN_CAPE = "WESTERN_CAPE",
}

export enum Platform {
  INVOICE_TOOL = "INVOICE_TOOL",
  MERCHANT_DASHBOARD = "MERCHANT_DASHBOARD",
}

export enum TenderType {
  PAYLINK = "PAYLINK",
}

export enum TenderStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  PAID = "PAID",
}

export enum RequestType {
  GET = "GET",
  PUT = "PUT",
  POST = "POST",
}

export enum Channel {
  WEB = "web",
  ANDROID_TOP = "android_top",
  IOS_TOP = "ios_top",
}
